import { countryList } from "./countryList"

const setTrue = (object, ...keys) => ({
    ...object,
    ...Object.fromEntries(keys.map((key) => [key, true])),
})

/**
 * Allow SSO content to be displayed
 * @returns {Boolean}
 */
export function isSSOAvailable() {
    const authorized = setTrue(countryList, "de", "tmpde")

    const lang = window.location.pathname.split("/")[1]

    return authorized[lang] ?? false
}

export function is2GAdviseAvailable() {
    const authorized = setTrue(
        countryList,
        "tmp",
        "en",
        "fr",
        "de",
        "tmpde",
        "tmpen",
    )

    const lang = window.location.pathname.split("/")[1]

    return authorized[lang] ?? false
}
